var React = require('react');

function BurgerInline (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_250_11690","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"40","height":"41","key":0},React.createElement("rect",{"y":"0.686905","width":"40","height":"40","fill":"currentColor"})),React.createElement("g",{"mask":"url(#mask0_250_11690)","key":1},React.createElement("path",{"d":"M5.83331 30.0776V27.5777H34.1666V30.0776H5.83331ZM5.83331 21.9366V19.4367H34.1666V21.9366H5.83331ZM5.83331 13.7956V11.2956H34.1666V13.7956H5.83331Z","fill":"currentColor"}))]);
}

BurgerInline.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = BurgerInline;

BurgerInline.default = BurgerInline;
